// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.newsEditor {
  color: #334155;
}
.newsEditor .container-fluid {
  padding-right: 0;
}
.newsEditor .row {
  margin-right: 0;
  margin-left: 0;
}
.newsEditor [class*='col-md-'] {
  max-width: 100%;
  flex: 0 0 100%;
  padding-right: 0;
  padding-left: 0;
}
.newsEditor .form-group {
  margin-bottom: 20px;
}
.newsEditor label {
  margin-bottom: 7px;
  color: #334155;
  font-size: 12px;
  font-weight: 750;
}
.newsEditor .form-control {
  min-height: 42px;
  padding: 9px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 9px;
  background: #fff;
  color: #142033;
  font-size: 13px;
  box-shadow: none;
}
.newsEditor .form-control:focus {
  border-color: #368fca;
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.11);
}
.newsEditor__datePicker {
  max-width: 320px;
}
.newsEditor__richText {
  overflow: visible;
  border-radius: 9px;
}
.newsEditor .invalid-feedback {
  display: block;
  margin-top: 5px;
  color: #b42338;
  font-size: 11px;
}
.newsEditor .eNewsTextEditor {
  position: relative;
  display: block !important;
}
.newsEditor .ql-container,
.newsEditor .ql-toolbar {
  border-color: #cbd5e1 !important;
}
.newsEditor .ql-toolbar {
  border-radius: 9px 9px 0 0;
  background: #f8fafc;
}
.newsEditor .ql-container {
  min-height: 180px;
  border-radius: 0 0 9px 9px;
  font-size: 13px;
}
.newsEditor__file {
  display: block;
  width: 100%;
  padding: 10px;
  border: 1px dashed #9fb4c7;
  border-radius: 10px;
  background: #f8fafc;
  color: #526174;
  font-size: 12px;
}
.newsEditor__file::file-selector-button {
  margin-right: 12px;
  padding: 7px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 7px;
  background: #fff;
  color: #334155;
  font-weight: 700;
}
.newsEditor__preview {
  position: relative;
  width: min(100%, 360px);
  margin: -6px 0 20px;
  overflow: hidden;
  border: 1px solid #dbe3ec;
  border-radius: 11px;
}
.newsEditor__preview img {
  display: block;
  width: 100%;
  max-height: 210px;
  object-fit: cover;
  border: 0 !important;
  border-radius: 0;
}
.newsEditor__removeImage {
  position: absolute;
  z-index: 1;
  top: 8px;
  right: 8px;
  width: 32px;
  height: 32px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  border-radius: 8px;
  background: rgba(15, 23, 42, 0.72);
  color: #fff;
  font-size: 20px;
  line-height: 26px;
}
.newsEditor__actions {
  display: flex;
  justify-content: flex-end;
  gap: 9px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #e5eaf0;
}
.newsEditor__cancel,
.newsEditor__save {
  min-height: 40px;
  padding: 0 16px;
  border-radius: 9px;
  font-size: 13px;
  font-weight: 700;
}
.newsEditor__cancel {
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #334155;
}
.newsEditor__save {
  border: 1px solid #227ebd;
  background: #227ebd;
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/components/NewsForm/NewsForm.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;;EAEE,gCAAgC;AAClC;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;;EAEE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb","sourcesContent":[".newsEditor {\n  color: #334155;\n}\n.newsEditor .container-fluid {\n  padding-right: 0;\n}\n.newsEditor .row {\n  margin-right: 0;\n  margin-left: 0;\n}\n.newsEditor [class*='col-md-'] {\n  max-width: 100%;\n  flex: 0 0 100%;\n  padding-right: 0;\n  padding-left: 0;\n}\n.newsEditor .form-group {\n  margin-bottom: 20px;\n}\n.newsEditor label {\n  margin-bottom: 7px;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 750;\n}\n.newsEditor .form-control {\n  min-height: 42px;\n  padding: 9px 12px;\n  border: 1px solid #cbd5e1;\n  border-radius: 9px;\n  background: #fff;\n  color: #142033;\n  font-size: 13px;\n  box-shadow: none;\n}\n.newsEditor .form-control:focus {\n  border-color: #368fca;\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.11);\n}\n.newsEditor__datePicker {\n  max-width: 320px;\n}\n.newsEditor__richText {\n  overflow: visible;\n  border-radius: 9px;\n}\n.newsEditor .invalid-feedback {\n  display: block;\n  margin-top: 5px;\n  color: #b42338;\n  font-size: 11px;\n}\n.newsEditor .eNewsTextEditor {\n  position: relative;\n  display: block !important;\n}\n.newsEditor .ql-container,\n.newsEditor .ql-toolbar {\n  border-color: #cbd5e1 !important;\n}\n.newsEditor .ql-toolbar {\n  border-radius: 9px 9px 0 0;\n  background: #f8fafc;\n}\n.newsEditor .ql-container {\n  min-height: 180px;\n  border-radius: 0 0 9px 9px;\n  font-size: 13px;\n}\n.newsEditor__file {\n  display: block;\n  width: 100%;\n  padding: 10px;\n  border: 1px dashed #9fb4c7;\n  border-radius: 10px;\n  background: #f8fafc;\n  color: #526174;\n  font-size: 12px;\n}\n.newsEditor__file::file-selector-button {\n  margin-right: 12px;\n  padding: 7px 12px;\n  border: 1px solid #cbd5e1;\n  border-radius: 7px;\n  background: #fff;\n  color: #334155;\n  font-weight: 700;\n}\n.newsEditor__preview {\n  position: relative;\n  width: min(100%, 360px);\n  margin: -6px 0 20px;\n  overflow: hidden;\n  border: 1px solid #dbe3ec;\n  border-radius: 11px;\n}\n.newsEditor__preview img {\n  display: block;\n  width: 100%;\n  max-height: 210px;\n  object-fit: cover;\n  border: 0 !important;\n  border-radius: 0;\n}\n.newsEditor__removeImage {\n  position: absolute;\n  z-index: 1;\n  top: 8px;\n  right: 8px;\n  width: 32px;\n  height: 32px;\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  border-radius: 8px;\n  background: rgba(15, 23, 42, 0.72);\n  color: #fff;\n  font-size: 20px;\n  line-height: 26px;\n}\n.newsEditor__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 9px;\n  margin-top: 24px;\n  padding-top: 16px;\n  border-top: 1px solid #e5eaf0;\n}\n.newsEditor__cancel,\n.newsEditor__save {\n  min-height: 40px;\n  padding: 0 16px;\n  border-radius: 9px;\n  font-size: 13px;\n  font-weight: 700;\n}\n.newsEditor__cancel {\n  border: 1px solid #cbd5e1;\n  background: #fff;\n  color: #334155;\n}\n.newsEditor__save {\n  border: 1px solid #227ebd;\n  background: #227ebd;\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
